import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';
import { AuditEvent } from '@wdx/clmi/clmi-swagger-gen';

@Injectable()
export class AuditsService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    getAudits(recordType: string, recordId: string): Observable<AuditEvent[]> {
        return this.http.get<AuditEvent[]>(
            `${
                this.config.getConfiguration().API_BASE
            }/audit/${recordType}/${recordId}`,
        );
    }
}
